import { render, staticRenderFns } from "./LContainer.vue?vue&type=template&id=a4230620&"
import script from "./LContainer.vue?vue&type=script&lang=js&"
export * from "./LContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports